import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'accessibleImg',
  pure: true
})
export class AccessibleImgPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(html: string): SafeHtml {
    if (!html) {
      return '';
    }

    // Create a temporary div to parse the HTML
    const div = document.createElement('div');
    div.innerHTML = html;

    // Find all image tags
    const images = div.querySelectorAll('img');

    // Process each image tag
    images.forEach(img => {
      // Check if the image doesn't have an alt attribute
      if (!img.hasAttribute('alt')) {
        // Add empty alt attribute and presentation role
        img.setAttribute('alt', '');
        img.setAttribute('role', 'presentation');
      }
    });

    // Return the modified HTML as safe HTML
    return this.sanitizer.bypassSecurityTrustHtml(div.innerHTML);
  }
}
